import { render, staticRenderFns } from "./gas.vue?vue&type=template&id=1729e80a&"
import script from "./gas.vue?vue&type=script&lang=js&"
export * from "./gas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports